import React from "react";
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';
import BreadCrumb from '../../components/BreadCrumb';

const ERPAutomation = () => {
    return (
        <div>
            <Navbar />
                <div class="container">
                    <BreadCrumb 
                        active_page="ERP Automation" 
                        prev_sub_page={{
                            'link':'/services',
                            'text':'Services'
                        }}
                        sub_page={{
                            'link':'/services/business-process',
                            'text':'Business Process'
                        }} 
                    />
                    <div class="inner-container">
                        <h2>ERP Automation</h2>
                        <p>Expand globally, run operations with ease using our integrated unified platform that seamlessly automates complex process of your enterprise.   </p>
                        <h3>Negate Need For Spreadsheets    </h3>
                        <p>An all in one platform that would automate any aspect of your business process be it finance, inventory, supply chain, sales, purchasing, human resources, customer relationship management, & so on.   </p>
                        <h3 className="text-center mt-5">How We Do</h3>
                        <img alt="" src={require('../../assets/images/services/erp-automation.png')} className="d-block m-auto mw-80 pb-5" />
                        <h3 className="text-center mt-5">Get The Most Of ERP Automation</h3>
                        <img alt="" src={require('../../assets/images/services/erp-automation-2.png')} className="d-block m-auto mw-80 pb-5" />
                        <h3 className="text-center mt-5">Engine Of Enterprise</h3>
                        <img alt="" src={require('../../assets/images/services/erp-automation-3.png')} className="d-block m-auto mw-80 pb-5" />
                    </div>
                </div>
            <Footer />
        </div>
    );
};

export default ERPAutomation;